import { i18nTranslate } from 'src/utils'

const renderReasonMessage = props => {
  const options = [
    {
      label: i18nTranslate('select.YourOption', 'Select Your Option'),
    },
  ]
  props &&
    props.reasonCode &&
    props.reasonCode.map(code => {
      options.push({
        label: code,
        value: code,
      })
    })
  return options
}
export const cancellationFormInput = props => {
  const cancelReasonMessage = renderReasonMessage(props)
  const cancelFormArray = [
    [
      {
        name: 'cancellationReason',
        dataTestId: 'qa-dropdown',
        type: 'select',
        ariaLabel: 'selectReason',
        options: cancelReasonMessage,
        columnType: {
          lg: '6',
          md: '9',
          sm: '9',
          xs: '12',
        },
      },
      {
        name: 'quantity',
        RenderProps: props.quantityProp,
      },
      {
        name: 'others',
        type: 'textarea',
        ariaLabel: 'otherReason',
        columnType: {
          lg: '9',
          md: '12',
        },
        customClassName: 'mt-3',
        className: 'pt-3',
        dataTestId: 'qa-order-cancel-other-reason',
      },
    ],
  ]
  return cancelFormArray
}
